import React, {useCallback, useState} from "react";
import {ConfigProvider} from "antd";
import {StringBuilder} from "../../AppUtils.js";
import {OrderStatusView} from "../../event/OrderStatusView/OrderStatusView.jsx";
import {calculateDeliveryTime, getOrderContactInfo} from "../../event/utils.jsx";
import "./delivery-info-page.css";
import {DeliveryProviderDeliveryStatus} from "../../dashboards/DeliveryProviderDashboard/DeliveryProviderDeliveries/consts.jsx";
import {ConfirmSlider, GoogleMapAddressNavigator} from "../../components";
import {InputWithSave} from "../../event/EventOrderV2.jsx";
import "./delivery-info-page.css";
import {ContactInfoTag, SectionInfo} from "./utils.jsx";
import {NOOP} from "../../utils/NOOP.jsx";

export const SourceDeliverySection = ({deliveryInfo = {}, onDeliveryStatusChange = NOOP, showHeader = true}) => {
    const [deliveryError, setDeliveryError] = useState(null);
    const [shouldShowDeliveryErrorInput, setShouldShowDeliveryErrorInput] = useState(null);

    const onChangeDeliveryStatus = useCallback(
        async (status, message) => {
            await onDeliveryStatusChange(deliveryInfo?.delivery?.deliveryId, status, message);
        },
        [deliveryInfo?.delivery?.deliveryId, onDeliveryStatusChange]
    );

    return (
        <ConfigProvider direction="rtl">
            <OrderStatusView
                className="delivery-info-pickup-container"
                title={
                    showHeader ? (
                        <div style={{display: "flex", columnGap: "5px", justifyContent: "space-between"}}>
                            <span>איסוף</span>
                            <span className="delivery-time-label">
                                {calculateDeliveryTime(deliveryInfo?.order ?? {})?.format("HH:mm")}
                            </span>
                        </div>
                    ) : null
                }
                description={[
                    <SectionInfo
                        key="address"
                        title="שם בית עסק:"
                        value={deliveryInfo?.order?.providerBrand}
                        contactsInfo={deliveryInfo?.order?.sourceOrderContactInfo ?? []}
                    />,
                    <SectionInfo
                        key="address"
                        title="כתובת:"
                        value={
                            <span className="address-wrapper">
                                <GoogleMapAddressNavigator
                                    key="destinationAddress"
                                    address={deliveryInfo?.delivery?.sourceAddress?.address}
                                    title={deliveryInfo?.delivery?.sourceAddress?.address}
                                />
                            </span>
                        }
                    />
                ]}
            />

            {!!shouldShowDeliveryErrorInput && (
                <InputWithSave
                    title="תיאור תקלה"
                    onSave={() => onChangeDeliveryStatus(DeliveryProviderDeliveryStatus.failed, deliveryError)}
                    disableSaveButton={!deliveryError}
                    isError={!deliveryError}
                    onTextChange={e => setDeliveryError(e.target.value)}
                />
            )}
        </ConfigProvider>
    );
};
